import { ReactNode } from 'react';

import backgroundGradient from '../gradient-bg.png';
import Smile from '../Smile';
interface BackgroundProps {
    children: ReactNode;
}

export const Background = ({ children }: BackgroundProps) => {
    return (
        <div className="min-h-[calc(100vh-64px)] relative py-8 md:pt-[72px] md:pb-16 px-5 bg-gradient-to-b from-[#0C342C] to-green-600 text-white">
            <div className="absolute top-32 left-0 w-full max-w-[98%] fw-svg">
                <Smile />
            </div>
            <div className="relative h-full z-10">{children}</div>
            <img src={backgroundGradient} className="absolute inset-0 top-auto w-full" alt="" />
        </div>
    );
};
